import MDModal from "components/MDModal";
import SoftBox from "components/SoftBox";
import PropTypes from "prop-types";
import { useState } from "react";
import { useAppServices } from "hook/services";
import Grid from "@mui/material/Grid";
import { CircularProgress } from "@mui/material";
import { useAgencyInfo } from "context/agency";
import PrimaryButton from "../../../components/PrimaryButton";

function ModalComponent({ open, onClose, handleRefresh }) {
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [file, setFile] = useState(null);
  const [openWarningModel, setOpenWarningModel] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      alert("Please select a file");
      return;
    }

    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("csvFile", file);
      formData.append("agency_id", agency._id);
      const payload = formData;
      const response = await AppService.business_tags.csvupload({ payload });
      if (response) {
        handleRefresh();
        onClose();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <MDModal open={openWarningModel} onClose={() => setOpenWarningModel(false)}>
        Already Reached your Limits to save Accounts
      </MDModal>
      {open && (
        <div className="modal-zz-confirm text-left">
          <div
            className="scrollable-modal-content bg-white rounded"
            style={{ position: "relative" }}
          >
            <h2 className="text-black text-left font-14"> Create Bulk Contacts </h2>
            <span className="crossison" onClick={onClose}>
              X
            </span>
            <SoftBox component="form">
              <Grid container spacing={0} maxHeight={"70vh"} overflow={"auto"}>
                <Grid item xs={12}>
                  <SoftBox className="mt-2">
                    <label className="text-black">Upload CSV File</label>
                    <p style={{fontSize:'12px'}}>CSV needs name and image headers</p>
                    <a
                      href="https://smartdirectory.ai/bulk-business-tag-upload-sample-csv"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="download-link"
                    >
                      Download Sample CSV
                    </a>
                  </SoftBox>
                </Grid>
                <Grid item xs={12}>
                  <SoftBox className="mt-2">
                    <input type="file" accept=".csv" name="csv" onChange={handleFileChange} />
                  </SoftBox>
                </Grid>
              </Grid>
              <SoftBox mt={4}>
                <button
                  className="savebtn-setting w-100"
                  type="button"
                  onClick={handleSubmit}
                  color="dark"
                  fullWidth
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Add"}
                </button>
              </SoftBox>
            </SoftBox>
          </div>
        </div>
      )}
    </>
  );
}

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func,
};

function CsvUploadModel({ handleRefresh }) {
  const [openAddMember, setOpenAddMember] = useState(false);

  return (
    <>
      <PrimaryButton
        type="button"
        className="sd-primary-btn--outline"
        onClick={() => setOpenAddMember(true)}
      >
        Upload CSV
      </PrimaryButton>
      <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        handleRefresh={handleRefresh}
      />
    </>
  );
}

CsvUploadModel.propTypes = {
  handleRefresh: PropTypes.func,
};

export default CsvUploadModel;
